/** @format */

import {styled} from '@mui/material/styles';
import {Box} from '@mui/material';

const PREFIX = 'WidgetStats';

const classes = {
  statsHeadingText: `${PREFIX}-statsHeadingText`,
};

const Root = styled(Box)(({theme}) => ({
  display: 'flex',
  flexDirection: 'column',

  [`.${classes.statsHeadingText}`]: {
    color: theme.palette.figma_gray_light_4?.main,
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '16px',
  },
}));

export {Root as WidgetStatsRoot, classes as widgetStatsClasses};
